import React from 'react'

type Props = { children: React.ReactNode }
const LimiterTable = ({ children }: Props) => <div className='limiter-table'>{children}</div>
export { LimiterTable }
